<template>
    <div class="form-row" :class="rowClass">
        <template v-for="field in fields">
            <template v-if="field.type === 'row'">
                <div class="col">
                    <form-row v-model="model" v-bind="field"></form-row>
                </div>
            </template>
            <template v-else>
                <div class="col">
                    <form-field v-model="model[field.name]" :model="model" v-bind="field"></form-field>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import FormField from './FormField';

export default {
    name: 'form-row',
    components: { FormField },
    props: {
        value: {
            required: true,
        },
        type: {
            required: true,
        },
        fields: {
            required: true,
        },
        rowClass: {
            default: null,
        },
    },
    data: () => ({
        model: null,
    }),
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal === oldVal) return;
                this.model = newVal ? newVal : {};
            },
        },
        model: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
};
</script>
